import { configureStore, Middleware, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
// 容错 storage：配额写满时先清「可再生」数据（旧画布快照等）再重试，
// 而不是每次 dispatch 都抛 QuotaExceededError（见 utils/storageQuota）
import { resilientPersistStorage } from '@/utils/storageQuota';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import imageGenerationReducer from './slices/imageGenerationSlice';
import videoGenerationReducer from './slices/videoGenerationSlice';
import toolsGenerationReducer from './slices/toolsGenerationSlice';
import generationReducer from './slices/generationSlice';
import crossPageSessionReducer from './slices/crossPageSessionSlice';
import spaceReducer from './slices/spaceSlice';

// 合并所有reducers
const rootReducer = combineReducers({
  imageGeneration: imageGenerationReducer,
  videoGeneration: videoGenerationReducer,
  toolsGeneration: toolsGenerationReducer,
  generation: generationReducer,
  crossPageSession: crossPageSessionReducer,
  space: spaceReducer,
  // ... 在这里可以添加其他reducers
});

// 定义持久化配置
const persistConfig = {
  key: 'root_new',
  storage: resilientPersistStorage,
  // 白名单: 持久化指定的reducer
  whitelist: ['imageGeneration', 'videoGeneration', 'toolsGeneration', 'crossPageSession', 'space'],
  // 黑名单: 不持久化特定的reducer
  // blacklist: [],
};

// 创建持久化reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 自定义中间件，用于打印action和state变化
const logger: Middleware = store => next => action => {
  if (process.env.NODE_ENV === 'development') {
    // 安全地访问action.type，避免类型错误
    const actionType =
      action && typeof action === 'object' && 'type' in action ? action.type : 'unknown';

    console.group(`%c Action: ${actionType}`, 'color: #4CAF50');
    console.log('%c Previous State:', 'color: #9E9E9E', store.getState());
    console.log('%c Action:', 'color: #03A9F4', action);
    const result = next(action);
    console.log('%c Next State:', 'color: #FF5722', store.getState());
    console.groupEnd();
    return result;
  }
  return next(action);
};

// 配置store
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // 忽略redux-persist的action
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== 'production',
});

// 创建persistor对象
export const persistor = persistStore(store);

// 类型定义
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
